import {inject, Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {EwToaster, ToasterType} from '@ew/ew-services-interfaces';
import {EventAction} from '@ew/models';
import {HotToastService} from '@ngxpert/hot-toast';

@Injectable({
  providedIn: 'root',
})
export class ToasterService implements EwToaster {
  //#region Dependencies

  private toastController = inject(ToastController);
  public toast = inject(HotToastService);

  //#endregion

  //#region Class methods

  /**
   * Displays a toast message on the screen with specific styling, buttons, and duration.
   *
   * @param {string} message
   * @param {ToasterType} type
   * @param {string} action
   * @param {number} duration
   *
   * @returns Promise<void>
   */
  private async showToaster(
    message: string,
    type: ToasterType,
    buttons: string[],
    duration = 5000,
  ): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'bottom',
      buttons,
      cssClass: `${type}-ion-toaster`,
    });

    return toast.present();
  }

  /**
   * This method displays a toaster message.
   *
   * @param message The warning message to display.
   * @param type ToasterType
   *
   * @returns void
   */
  public displayToast(
    message: string,
    type: ToasterType,
    action?: string | EventAction<any>,
    config?: any,
  ): void {
    // this.toast.show('Hello World!');
    // this.toast.loading('Lazyyy...');
    // this.toast.success('Yeah!!');
    // this.toast.warning('Boo!');
    // this.toast.error('Oh no!');
    // this.toast.info('Something...');

    switch (type) {
      case ToasterType.Success:
        this.toast.success(message);
        // this.showSnackBar(message, ToasterType.Success, 'OK');
        break;
      case ToasterType.Error:
        this.toast.error(message);
        // this.showSnackBar(message, ToasterType.Error, 'OK');
        break;
      default:
        this.toast.warning(message);
        // this.showSnackBar(message, ToasterType.Warn, 'OK');
        break;
    }
  }

  observedToaster() {
    return this.toast.observe({
      loading: 'Saving...',
      success: () => 'I got a response: ',
      error: () => 'Something did not work, reason: ',
    });
  }

  //#endregion
}
